/* eslint-disable react/no-unescaped-entities */
import LegalLayout from "./LegalLayout";
import { COMPANY } from "./_company";

export default function Retours() {
  return (
    <LegalLayout
      eyebrow="Boutique · Retours"
      title="Retours et remboursements"
      lastUpdated={COMPANY.effectiveDate}
      intro={`Vous disposez de ${COMPANY.returnDays} jours pour changer d'avis sur nos produits physiques. Voici comment procéder.`}
    >
      <h2>1. Droit de rétractation légal</h2>
      <p>
        Conformément aux articles L221-18 et suivants du Code de la consommation, vous disposez
        d'un délai de <strong>{COMPANY.returnDays} jours calendaires</strong> à compter de la
        réception de votre commande pour exercer votre droit de rétractation, sans avoir à
        justifier de motifs ni à payer de pénalités, à l'exception des frais de retour.
      </p>

      <h2>2. Produits exclus du droit de rétractation</h2>
      <p>
        Conformément à l'article L221-28 du Code de la consommation, le droit de rétractation{" "}
        <strong>ne s'applique pas</strong> aux catégories suivantes :
      </p>
      <ul>
        <li>
          <strong>Ebooks numériques</strong> — l'exécution du contrat commence dès la confirmation
          du paiement. En achetant un ebook, vous reconnaissez expressément renoncer à votre
          droit de rétractation (article L221-28 13°).
        </li>
        <li>
          <strong>Produits scellés ouverts</strong> et impropres à être renvoyés pour des raisons
          d'hygiène (article L221-28 5°) — concerne notamment certaines épices et préparations
          alimentaires dont l'emballage a été ouvert.
        </li>
      </ul>

      <h2>3. Comment retourner un produit</h2>
      <ol>
        <li>
          Contactez-nous à <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a> dans les{" "}
          {COMPANY.returnDays} jours suivant la réception, en indiquant votre numéro de commande
          et la raison du retour.
        </li>
        <li>
          Nous vous communiquons l'adresse de retour et un numéro de retour à inscrire sur le colis.
        </li>
        <li>
          Vous renvoyez le produit dans son emballage d'origine, intact et non utilisé, sous{" "}
          <strong>14 jours suivant votre notification</strong>.
        </li>
        <li>
          Une fois le produit reçu et inspecté, nous vous remboursons sous{" "}
          <strong>14 jours maximum</strong> sur le moyen de paiement initial.
        </li>
      </ol>

      <h2>4. Frais de retour</h2>
      <p>
        Sauf erreur de notre part (produit défectueux, non conforme à la commande), les frais de
        retour sont à votre charge. Nous vous recommandons un envoi suivi.
      </p>
      <p>
        <strong>En cas de produit défectueux ou non conforme</strong>, BAYO prend en charge les frais
        de retour et procède soit au remplacement, soit au remboursement intégral selon votre
        préférence.
      </p>

      <h2>5. Remboursement</h2>
      <p>
        Le remboursement est effectué via le moyen de paiement utilisé lors de la commande
        (carte bancaire), dans un délai maximum de 14 jours après réception et inspection du
        produit retourné. Le montant remboursé comprend le prix du produit et les frais de
        livraison initiaux (hors frais de retour).
      </p>

      <h2>6. Garanties légales</h2>
      <p>
        Indépendamment du droit de rétractation, vous bénéficiez de :
      </p>
      <ul>
        <li>
          La <strong>garantie légale de conformité</strong> (articles L217-4 à L217-14 du Code de la
          consommation) : 2 ans à compter de la livraison.
        </li>
        <li>
          La <strong>garantie contre les vices cachés</strong> (articles 1641 à 1649 du Code civil) :
          2 ans à compter de la découverte du vice.
        </li>
      </ul>
      <p>
        Pour exercer une garantie, contactez-nous à{" "}
        <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a> en décrivant précisément le problème
        et en joignant des photos si possible.
      </p>
    </LegalLayout>
  );
}
